import { render } from "./GABQnMANC.vue?vue&type=template&id=2ad270c9&scoped=true"
import script from "./GABQnMANC.vue?vue&type=script&lang=js"
export * from "./GABQnMANC.vue?vue&type=script&lang=js"

import "./GABQnMANC.vue?vue&type=style&index=0&id=2ad270c9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad270c9"]])

export default __exports__